export enum DefaultMetricsGroup {
    Ml = 'ml',
    Algo = 'algo'
}
